import script from "./FileTypesPolicy.vue?vue&type=script&setup=true&lang=js"
export * from "./FileTypesPolicy.vue?vue&type=script&setup=true&lang=js"

import "./FileTypesPolicy.vue?vue&type=style&index=0&id=a3acf4b4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3acf4b4"]])

export default __exports__